<template>
    <div>
Delivery price
    </div>
</template>

<script>
export default {
    name: "DeliveryPrice",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
